import { StyleSheet, Text, View } from "react-native";

import {
  spacing,
  typography,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function PageTitle({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View style={stylesheet.block}>
      <Text accessibilityRole="header" style={stylesheet.title}>
        {title}
      </Text>
      {subtitle ? <Text style={stylesheet.subtitle}>{subtitle}</Text> : null}
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    block: { gap: spacing.xs },
    title: {
      ...typography.display1,
      color: colors.heading,
    },
    subtitle: {
      ...typography.body,
      color: colors.mutedForeground,
    },
  });
